export default "__VITE_ASSET__BWbbiCbh__"